import Component from '../inherited/Component'

class SideCart extends Component {
    constructor (elem, theme, options, ctx) {
        super(elem, theme, options, ctx)
    }

    async mount () {
        this._ctx.on('show-side-cart', async () => {
            this.showSideCart()
        })

        /* 
          The configurator requires us to remove the tdaId parameter from the URL to be able to add multiple of the same variant to cart,
          so we store the item that was added in localStorage, remove the parameter and refresh the page, and then grab the item from localStorage and delete it before showing the side cart
        */

        window.addEventListener('Angle3DAddToCart', async (event) => {

          let itemAdded = {
            id: event.detail.variantId,
            quantity: event.detail.quantity,
            properties: [],
            selling_plan: []
          }
        
          localStorage.setItem('AngleATC', JSON.stringify(itemAdded))

          let params = new URLSearchParams(window.location.search)
          params.delete('tdaId')
          history.replaceState(null, '', '?' + params + window.location.hash)
          location.reload(true)
        });

        if(localStorage.getItem('AngleATC')) {
          let angleItemAdded = JSON.parse(localStorage.getItem('AngleATC'))
          this._ctx.emit('cart-item-added', {
            lastItemAdded: {
              item: angleItemAdded,
              quantity: angleItemAdded.quantity,
              properties: angleItemAdded.properties
            }
          })
          localStorage.removeItem('AngleATC')
          this._ctx.emit('show-side-cart')
        }

        this._doEditorListeners()
    }

    showSideCart () {
        this._scrollArea = this._elem.querySelector('.inner-scroll')
        this._elem.classList.add('shown')
        this._ctx.emit('ffc--scroll-lock-elem', null, document.querySelector('body'))
        this._ctx.emit('ffc--scroll-unlock-elem', null, this._scrollArea)
        this._ctx.on('cart-item-added--refreshed', (state, data) => {
             this._scrollArea = this._elem.querySelector('.inner-scroll')
             if (this._elem.classList.contains('shown')) {
                 this._ctx.emit('ffc--scroll-unlock-elem', null, this._scrollArea)
             }
        })
    }

    _doEditorListeners () {
      document.addEventListener('shopify:section:select', e => {
        if (e.target.contains(this._elem)) {
          this._elem.classList.add('shown')
        }
      })

      document.addEventListener('shopify:section:deselect', e => {
        if (e.target.contains(this._elem)) {
          this._elem.classList.remove('shown')
        }
      })
    }
}

export default SideCart
